import * as React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import { ToolbarButton } from '@mui/x-data-grid-premium';

export const SaveCurrentViewButton = ({ label, onLabelChange, onSubmit, onCancel, isValid }) => {
  const [isAddingView, setIsAddingView] = React.useState(false);

  const handleSubmitForm = e => {
    onSubmit();
    setIsAddingView(false);
    e.preventDefault();
  };

  const handleCancel = () => {
    setIsAddingView(false);
    onCancel();
  };

  return (
    <React.Fragment>
      <Tooltip title="Save current view">
        <ToolbarButton onClick={() => setIsAddingView(true)}>
          <AddIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>
      <Dialog onClose={handleCancel} open={isAddingView}>
        <form onSubmit={handleSubmitForm}>
          <DialogTitle>Save custom view</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              value={label}
              onChange={onLabelChange}
              margin="dense"
              size="medium"
              label="Custom view label"
              variant="standard"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button type="button" onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="submit" disabled={!isValid}>
              Create view
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};
